export default class HoldingTransaction {
	constructor() {
		this.TransactionDate = null;
		this.TransactionType = null;
		this.Exchange = null;
		this.NumberOfShares = null;
		this.PricePerShare = null;
		this.Brokerage = null;
	}
}
